"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_js_JSONserialize = exports.SHu_js_timeSince = exports.SHu_js_splitArrayIntoChunks = exports.SHu_JSONtryParse = exports.SHu_JSONcheckValid = exports.SHu_js_sleep = exports.SHu_js_swapTwoElementsInArray = exports.SHu_js_flattenObject = exports.SHu_js_formatPhoneNumber = exports.SHu_js_percentageFormat = exports.SHu_js_currencyFormat = exports.SHu_js_upperFirstLetter = void 0;
const SHu_js_upperFirstLetter = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
exports.SHu_js_upperFirstLetter = SHu_js_upperFirstLetter;
const SHu_js_currencyFormat = (val, format) => new Intl.NumberFormat("en-US", Object.assign({ style: "currency", currency: "USD" }, format)).format(Number(val));
exports.SHu_js_currencyFormat = SHu_js_currencyFormat;
const SHu_js_percentageFormat = (v, format) => new Intl.NumberFormat("en-US", Object.assign({ style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }, format)).format(Number(v));
exports.SHu_js_percentageFormat = SHu_js_percentageFormat;
const SHu_js_formatPhoneNumber = (phoneNumber) => {
    const cleaned = phoneNumber.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
    if (match)
        return `(${match[1].padEnd(3, "_")}) ${match[2].padEnd(3, "_")} - ${match[3].padEnd(4, "_")}`.trim();
    return phoneNumber;
};
exports.SHu_js_formatPhoneNumber = SHu_js_formatPhoneNumber;
const SHu_js_flattenObject = (ob) => {
    var toReturn = {};
    for (var i in ob) {
        if (!ob.hasOwnProperty(i))
            continue;
        if (typeof ob[i] === "string") {
            try {
                ob[i] = JSON.parse(ob[i]);
            }
            catch (e) {
                ob[i] = ob[i];
            }
        }
        if (typeof ob[i] == "object" && ob[i] !== null) {
            var flatObject = (0, exports.SHu_js_flattenObject)(ob[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x))
                    continue;
                toReturn[i + "." + x] = flatObject[x];
            }
        }
        else {
            toReturn[i] = ob[i];
        }
    }
    return toReturn;
};
exports.SHu_js_flattenObject = SHu_js_flattenObject;
const SHu_js_swapTwoElementsInArray = (arr, index1, index2) => {
    if (!arr[index1] || !arr[index2])
        return arr;
    var temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
};
exports.SHu_js_swapTwoElementsInArray = SHu_js_swapTwoElementsInArray;
const SHu_js_sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.SHu_js_sleep = SHu_js_sleep;
const SHu_JSONcheckValid = (str) => {
    try {
        JSON.parse(str);
        return true;
    }
    catch (error) {
        return false;
    }
};
exports.SHu_JSONcheckValid = SHu_JSONcheckValid;
const SHu_JSONtryParse = (str, fallback) => ((0, exports.SHu_JSONcheckValid)(str) ? JSON.parse(str) : fallback);
exports.SHu_JSONtryParse = SHu_JSONtryParse;
const SHu_js_splitArrayIntoChunks = (arr, chunkSize) => {
    chunkSize = Math.floor(chunkSize);
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
};
exports.SHu_js_splitArrayIntoChunks = SHu_js_splitArrayIntoChunks;
const SHu_js_timeSince = (pass, now = Date.now()) => {
    var seconds = Math.floor((now - Number(pass)) / 1000);
    var interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + "Y ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + "Mo ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + "D ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + "H ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + "Mi ago";
    }
    return Math.floor(seconds) + "S ago";
};
exports.SHu_js_timeSince = SHu_js_timeSince;
const SHu_js_JSONserialize = (val) => {
    if (val == null)
        return null;
    const serializedValue = Array.isArray(val) && typeof val[0] === "object"
        ? val.map((o) => (0, exports.SHu_js_JSONserialize)(o)).sort()
        : typeof val === "object"
            ? Object.keys(val)
                .sort()
                .reduce((acc, cur) => (Object.assign(Object.assign({}, acc), { [cur]: typeof val[cur] === "object" ? (0, exports.SHu_js_JSONserialize)(val[cur]) : val[cur] })), {})
            : val.toString();
    return JSON.stringify(serializedValue);
};
exports.SHu_js_JSONserialize = SHu_js_JSONserialize;
